import FontIcon from '@gik/ui/FontIcon';
import iconMap from '@gik/core/iconMap';

// Setup icon mapping for the FontIcon component
FontIcon['iconMap'] = iconMap;
